import Form, { UserFormMode } from "./Form";
import React, { useContext, useState } from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { HomeAppContext } from "../../Home";
import Slide from "@mui/material/Slide";
import api from "../../../Services/api";
import { errorManagement } from "../../../Services/errorManagement";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Edit({ open, setOpen, entry, onEdit }) {
  const { homeDispatch } = useContext(HomeAppContext);

  const [internalEntry, setInternalEntry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState([]);

  React.useEffect(() => {
    if (entry !== null && open) {
      const updateEntry = {
        ...entry,
        changePassword: false,
        newPassword: "",
        newPasswordRepeat: "",
        pictureChanged: false
      };
      setInternalEntry(updateEntry);
      setErrors([]);
      setLoading(false);
      setSubmitted(false);
    } else {
      setInternalEntry(null);
    }
  }, [entry, open]);

  const handleClose = () => {
    setOpen(false);
    setLoading(true);
  };

  const handleCloseSave = () => {
    if (
      internalEntry.changePassword &&
      internalEntry.newPassword !== internalEntry.newPasswordRepeat
    ) {
      homeDispatch({
        type: "NOTIFICATION",
        data: { message: "The password is invalid", type: "error" }
      });
      return;
    }

    const updateUser = {
      id: internalEntry.id,
      fullName: internalEntry.fullName,
      email: internalEntry.email,
      roleId: internalEntry.role !== "" ? internalEntry.role.id : 0,
      picture: internalEntry.pictureChanged ? internalEntry.picture : null,
      active: internalEntry.active,
      atmsUser: internalEntry.atmsUser,
      atmsUserAdditional: internalEntry.atmsUserAdditional,
      xtrfUser: internalEntry.xtrfUser,

      password:
        internalEntry.newPassword === internalEntry.newPasswordRepeat &&
        internalEntry.newPassword !== ""
          ? internalEntry.newPassword
          : null
    };

    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Updating user", loading: true }
    });
    setSubmitted(true);
    setLoading(true);
    api
      .put(`/api/users/${updateUser.id}`, updateUser)
      .then((response) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: { message: "User updated", type: "success" }
        });
        setOpen(false);
        setLoading(false);
        onEdit();
      })
      .catch((error) => {
        setLoading(false);
        errorManagement.formErrors(error, homeDispatch, setErrors);
      });
  };

  return internalEntry === null ? null : (
    <Dialog
      maxWidth={"sm"}
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      aria-labelledby="alert-dialog-edit-entry"
    >
      <DialogTitle id="alert-dialog-edit-entry">{"Edit User"}</DialogTitle>
      <DialogContent>
        <Form
          mode={UserFormMode.EDIT}
          entity={internalEntry}
          errors={errors}
          setEntity={setInternalEntry}
          loading={loading}
          submitted={submitted}
          setSaveDisabled={setSaveDisabled}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleCloseSave}
          color="primary"
          autoFocus
          disabled={loading || saveDisabled}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
